<template>
  <bsp-dialog class="dialog-card" :title="$t('cost.cost072')" :dialogVisible.sync="visible" @closeButton="closeDialog" width="850px" :needMinHeight="false"><!-- 上传票据 -->
    <template #body v-loading="loading">
      <div class="upload-container flex">
        <el-card class="upload-left" shadow="always" v-show="params.editFlag != 'view'">
          <div class="upload-title">{{$t('cost.cost073')}}</div><!-- 可选择文件或微信扫码上传附件 -->
          <div class="upload-type">
            <vue-qr :text="qrUrl" :margin="0" colorDark="#000" colorLight="#fff" :size="120"></vue-qr>
            <p class="upload-description">{{$t('cost.cost074')}}</p><!-- 微信扫码上传 -->
          </div>
          <div class="upload-type">
            <el-upload
              ref="upload"
              action="#"
              :before-upload="beforeUpload"
              :show-file-list="false"
              :http-request="function (file) { return fileChange(file)}"
              accept=".pdf,.png,.jpg,.jpeg,.gif,.xls,.xlsx,.doc,.docx,.txt,.ppt,.pptx"
              multiple>
              <el-button slot="trigger" type="primary" :disabled="demoLoading" style="width: 120px;" round>{{$t('cost.cost075')}}</el-button><!-- 选择文件 -->
            </el-upload>
            <p class="upload-description">{{$t('cost.cost076')}}</p><!-- 点击按钮上传附件 -->
          </div>
        </el-card>
        <el-card class="upload-right" shadow="always">
          <div class="upload-title">{{$t('cost.cost077')}}</div><!-- 附件列表 -->
          <div class="upload-file-list">
            <template v-if="fileList && fileList.length">
              <div class="file-item" v-for="(file, index) in fileList" :key="index" @click="viewFile(file)">
                <span class="file-name">
                  <el-button type="text" :underline="false" size="medium">{{file.fileName}}</el-button>
                </span>
                <span class="file-size">{{file.attachmentSizeFormat}}</span>
                <svg class="icon file-ope" aria-hidden="true" @click.stop="deleteImg(index)" v-show="params.editFlag != 'view'">
                  <use xlink:href="#icon-guanbi"></use>
                </svg>
              </div>
            </template>
            <bsp-empty :description="$t('cost.cost083')" v-else /><!-- 暂无附件 -->
          </div>
        </el-card>
      </div>
    </template>
    <div class="dialog-footer" slot="footer" v-if="params.editFlag != 'view'">
      <el-button type="default" @click="closeDialog">{{$t('cost.cost079')}}</el-button><!-- 取 消 -->
      <el-button type="primary" @click="submitForm('mainForm')" :loading="loading" :disabled="demoLoading">{{$t('cost.cost078')}}</el-button><!-- 确 定 -->
    </div>
    <!-- 没有实质的用处，解决页面不刷新-->
    <div v-show="false">
      <div v-for="ff in fileListRefresh" :key="ff">{{ff}}</div>
    </div>
  </bsp-dialog>
</template>
<script>
import BspDialog from "@/components/bsp/bsp-dialog/bsp-dialog";
import VueQr from 'vue-qr'
import { uploadFile, downloadQiniuFile, queryAttachByIds } from "@/api/sys/sys";
import { downloadFile } from '@/util/util'
import { mapGetters } from 'vuex';
import {getCloudConstractPaymentInfo} from "@/api/cost/cost";

export default {
  name: "UploadAttach",
  components: {
    BspDialog, VueQr
  },
  props:{
    params: {
      type: Object,
      default: function (){
        return {
          batchId:"",
          btnType:"",
        };
      },
    },
  },
  computed: {
    ...mapGetters([
      'accessToken',
      'dicts'
    ]),
    codeMap() {
      return this.dicts.codeMap;
    }
  },
  watch: {
  },
  created() {
  },
  data () {
    return {
      labelName : "",
      demoLoading: false,
      visible: false,
      searchParams: {},
      pageTitle: "",
      qrUrl: "",
      mainForm: {
      },
      fileList: [],
      fileListRefresh:[], //没有特殊的作用解决v-for不刷新
      addattachIds:"",
    }
  },
  methods: {
    init() {
      // vue版本目前不需要这个逻辑
      // if(!this.params.batchId){
      //   this.params.batchId = this.guid();
      // }

      //获取微信扫码图片
      this.codeScan(this.params.batchId);

      if(this.params.type == "invoiceFolderOcr"){
        // this.fileList.push({
        //   fileName: "一张全电增值税票.pdf",
        //   attachmentSizeFormat: "311 KB",
        //   attachmentId: "0836e6a28b264c339f475ccc89834f3c",
        // });
        //
        // this.fileList.push({
        //   fileName: "两张飞机票.png",
        //   attachmentSizeFormat: "11.3 MB",
        //   attachmentId: "314ac44e26024ca1aef713f75240961d",
        // });
      }

      if(this.params.detailAttachIds){
        this.queryAttachByIds(this.params.detailAttachIds);
      }

    },
    guid() {
      return 'xxxxxxxxxxxxxxxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0,
          v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    },
    codeScan(querydata){
      if(querydata){
        var pageLink = "https://hrcloud.ciicpt.com.cn/wechatMPUpload?fileFlag=";
        //var testText = "8719816c3f6c4633a7364d2ac4eb43d8";
        var testText = querydata;
        this.qrUrl = pageLink+testText;
      }
    },
    queryAttachByIds(attachIds) {
      let params = {
        searchParams : {
          attachIds : attachIds
        }
      }

      var that = this;
      queryAttachByIds(params)
        .then((response) => {
          this.demoLoading = false;
          let result = response.data;
          console.log("queryAttachByIds", result)
          if(result.code == '0'){
            var attachList = result.data;
            if(attachList != null && attachList.length > 0){
              var detailSourceAttachId = this.params.detailSourceAttachId;
              for(var i = 0; i < attachList.length; i++){
                var attachBO = attachList[i];
                if(detailSourceAttachId && detailSourceAttachId.indexOf(attachBO.attachmentId) > -1){
                  attachBO.deleteFlag = "false";
                }
                this.fileList.push(attachBO);
              }
            }

          }else{
            this.$message.success(result.msg);
          }

        })
        .catch(error => {
          this.demoLoading = false;
          console.log("error", error)
          this.$message.error(this.$t('homepage.txt024'));//请求异常！
        });

    },
    // 清空表单
    resetForm (formName) {
      if (this.$refs[formName] !== undefined) {
        this.$refs[formName].resetFields();
      }
    },
    // 上传前处理
    beforeUpload(file) {
      const isLt20M = file.size / 1024 / 1024 < 20;
      if (file.size <= 0){
        this.$message.error(this.$t("cost.invoice061")); //导入文件为空，请重新选择正确的文件上传!
        return false;
      }
      if (!isLt20M) {
        this.$message.error(this.$t("cost.invoice062") + ' 20MB!'); //上传文件大小不能超过
        // this.$Loading.close();
        return isLt20M;
      }
      var fileNamesArr = file.name.split(".");
      var fileType = fileNamesArr[fileNamesArr.length - 1];
      if(".pdf,.png,.jpg,.jpeg,.gif,.xls,.xlsx,.doc,.docx,.txt,.ppt,.pptx,".indexOf("."+fileType+",") == -1){
        this.$message.error('['+fileType+']' + this.$t('cost.cost080')); //不支持此类型的文件!
        return false;
      }
      // this.$Loading.full();
      return true;
    },
    // 上传文件
    fileChange(file) {

      let _this = this
      let fileName = file.file.name
      let reader = new FileReader();
      reader.readAsDataURL(file.file);
      reader.onload = function() {
        let base64Str = this.result;
        let startNum = (base64Str.indexOf("base64,")) * 1 + 7;
        let baseStr = base64Str.slice(startNum);

        let params = {
          mainForm : {
            fileName : fileName,
            baseStr : baseStr,
          }
        }

        this.demoLoading = true;

        uploadFile(params)
          .then((response) => {
            this.demoLoading = false;
            let result = response.data;
            if(result.code == '0'){
              _this.fileList.push(result.data);
              _this.fileListRefresh.push(result.data); //没有实质的用处，解决页面不刷新
            }else{
              this.$message.success(result.msg);
            }
          })
          .catch(error => {
            this.demoLoading = false;
            console.log("error", error)
            this.$message.error(this.$t('homepage.txt024'));//请求异常！
          });

        // fileList.push({
        //   fileName : fileName,
        //   baseStr : baseStr
        // });
        // _this.fileListRefresh.push({fileName:fileName}); //没有实质的用处，解决页面不刷新
      }
    },
    deleteImg(index){
      var that = this;
      this.$confirm(this.$t("homepage.txt022") + "?", this.$t("homepage.txt017"), {//您确定要删除文件?  提示
        confirmButtonText: this.$t("homepage.txt018"), //确认
        cancelButtonText: this.$t("homepage.txt019"),//取消
        type: 'warning'
      }).then(() => {
        that.fileList.splice(index, 1);
        that.fileListRefresh.push({fileName:index})
      }).catch(() => {
      });
    },
    download(file){
      let params = {
        mainForm : {attachmentId : file.attachmentId}
      }

      downloadQiniuFile(params)
        .then((res) => {
          this.demoLoading = false;
          downloadFile(res);
        })
        .catch(error => {
          this.demoLoading = false;
          console.log("error", error)
          this.$message.error(this.$t('homepage.txt024'));//请求异常！
        });
    },
    viewFile(file){
      window.open('/api/sys/viewAttachFile?fileId='+ file.attachmentId, '_blank')
    },
    closeDialog () {
      const that = this;
      if(this.params.editFlag == 'view'){
        that.clearForm();
        that.visible = false;
      }else{
        this.$confirm(
          this.$t("cost.invoice059"), //是否放弃当前操作
          this.$t("homepage.txt017"), //提示
          {
            type: 'warning'
          }
        ).then(function(){
          //确认操作
          that.clearForm();
          that.visible = false;
        }).then((data) => {
          //取消操作
        }).catch(function (err) {
          //捕获异常
        });
      }


    },
    close (){
      this.clearForm();
      this.resetForm("mainForm");
      this.visible = false;
    },

    // 级联change事件，清空子项下拉选项和选中值
    clearForm() {
      // 获取语言
      this.fileList = [];
      this.fileListRefresh = [];
      this.addattachIds = "";
      this.params = {
        batchId:"",
        btnType:"",
      };
      this.resetForm('mainForm');
    },
    // 确认
    submitForm (formName) {

      if(this.params.type == "invoiceFolderOcr"){
        if(this.fileList.length == 0){
          this.$message.error(this.$t('cost.cost081')); //未识别到票据，请先上传票据后再提交！
          return ;
        }

        var that = this;
        this.$confirm(
          this.$t('cost.cost082'), //是否确认提交票据识别！
          this.$t("homepage.txt017"), //提示
          {
            type: 'warning'
          }
        ).then(function(){
          //确认操作
          that.doSubmit();
        }).then((data) => {
          //取消操作
        }).catch(function (err) {
          //捕获异常
        });
      }else{
        this.doSubmit();
      }


    },
    doSubmit(){
      const returnList = this.fileList.map(item => ({...item})); // 深拷贝对象数组中的每个对象
      this.$emit('reload', returnList);
      this.clearForm();
      this.visible = false;
    },
  }
}
</script>

<style lang="scss" scoped>
  .upload-container {
    gap: 20px;
    .upload-title {
      font-size: 15px;
      font-weight: 500;
      margin-bottom: 20px;
      text-align: left;
      line-height: 20px;
      color: #333;
    }
  }
  .upload-left {
    width: 260px;
    text-align: center;
    .upload-type {
      margin-bottom: 20px;
      padding: 20px 0;
      border: 1px solid #f1f1f1;
      -webkit-border-radius: 6px;
      -moz-border-radius: 6px;
      border-radius: 6px;
      transition: .3s;
      &:hover {
        -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
        -moz-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
      }
      .upload-description {
        margin-top: 15px;
      }
    }
  }
  .upload-right {
    flex: 1;
    .upload-file-list {
      .file-item {
        width: 100%;
        height: 30px;
        padding: 0 15px;
        -webkit-border-radius: 4px;
        -moz-border-radius: 4px;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        &:hover {
          cursor: pointer;
          background-color: #fef0f0;
        }
        .file-name {
          display: inline-block;
          width: 320px;
        }
        .file-size {
          width: 80px;
          text-align: right;
        }
        .file-ope {
          margin-left: 10px;
          font-size: 16px;
          cursor: pointer;
          color: #DE4A4A;
        }
      }
    }
  }
</style>
